/**
 * @description body 组件
 */

import {h, Component} from 'preact';
import './body.scss';

import Message from 'components/message/message';
import SDK from 'lib/sdk';

export default class Body extends Component{
  constructor(props){
    super(props);

    this.state = {
      msgList: []
    }
  }

  componentWillMount(){
    this.setState({
      msgList: this.state.msgList.concat(SDK.getMsgList())
    });

    SDK.onMsgChange((msg)=>{
      this.setState({
        msgList: this.state.msgList.concat(msg)
      });
    });
  }

  componentDidUpdate(){
    this.gotoBottom();
  }

  gotoBottom(){
    this.hook.scrollIntoView();// 滚动到底部
  }

  render(props, {msgList, ...state}){
    let nearShowTime = 0;

    let vMessages = msgList.map((msg, i)=>{
      let showTime = true;

      // 控制时间的展示 间隔 3 分钟
      if(i === 0){
        nearShowTime = msg.time;
      } else {
        let dt = msg.time - nearShowTime;

        if(dt > 3 * 60 * 1000){
          nearShowTime = msg.time;
        }else{
          showTime = false;
        }
      }

      return <Message {...msg} showTime={showTime}/>
    });

    return (
      <div class='app__body'>
        {vMessages}
        <div ref={(ref)=>{this.hook = ref;}}/>
      </div>
    )
  }
}


/** WEBPACK FOOTER **
 ** ./components/body/body.jsx
 **/